import { Subject } from "rxjs";

export interface RunNowDialogRequest {
  scheduleUid: string;
  scheduleName: string;
  /** A run something else already started: the dialog skips the reason form and follows this jobevent. */
  jobEventUid?: string;
}

/** Emit a request to open the Run Now dialog, or undefined to close it. Kept out of the .tsx so
 *  RunNowDialog exports only its component (a React Fast Refresh requirement). */
export const showRunNowDialog = new Subject<RunNowDialogRequest | undefined>();

export function openRunNowDialog(req: RunNowDialogRequest): void {
  showRunNowDialog.next(req);
}
